/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ImportTrackItMeasurementForWorkStepDto } from './ImportTrackItMeasurementForWorkStepDto';
import {
    ImportTrackItMeasurementForWorkStepDtoFromJSON,
    ImportTrackItMeasurementForWorkStepDtoFromJSONTyped,
    ImportTrackItMeasurementForWorkStepDtoToJSON,
} from './ImportTrackItMeasurementForWorkStepDto';

/**
 * 
 * @export
 * @interface ImportTrackItMeasurementsForWorkItemDto
 */
export interface ImportTrackItMeasurementsForWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementsForWorkItemDto
     */
    jobOccurrenceId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementsForWorkItemDto
     */
    workItemId: string;
    /**
     * 
     * @type {Array<ImportTrackItMeasurementForWorkStepDto>}
     * @memberof ImportTrackItMeasurementsForWorkItemDto
     */
    importMeasurementsForWorkSteps: Array<ImportTrackItMeasurementForWorkStepDto>;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementsForWorkItemDto
     */
    $type?: ImportTrackItMeasurementsForWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const ImportTrackItMeasurementsForWorkItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoImportTrackItMeasurementsForWorkItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementsForWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ImportTrackItMeasurementsForWorkItemDtoTypeEnum = typeof ImportTrackItMeasurementsForWorkItemDtoTypeEnum[keyof typeof ImportTrackItMeasurementsForWorkItemDtoTypeEnum];



/**
 * Check if a given object implements the ImportTrackItMeasurementsForWorkItemDto interface.
 */
export function instanceOfImportTrackItMeasurementsForWorkItemDto(value?: unknown): value is ImportTrackItMeasurementsForWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ImportTrackItMeasurementsForWorkItemDtoTypeEnum)[0];
}

export function ImportTrackItMeasurementsForWorkItemDtoFromJSON(json: any): ImportTrackItMeasurementsForWorkItemDto {
    return ImportTrackItMeasurementsForWorkItemDtoFromJSONTyped(json, false);
}

export function ImportTrackItMeasurementsForWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTrackItMeasurementsForWorkItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'jobOccurrenceId': json['jobOccurrenceId'],
        'workItemId': json['workItemId'],
        'importMeasurementsForWorkSteps': ((json['importMeasurementsForWorkSteps'] as Array<any>).map(ImportTrackItMeasurementForWorkStepDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ImportTrackItMeasurementsForWorkItemDtoToJSON(value?: ImportTrackItMeasurementsForWorkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'jobOccurrenceId': value['jobOccurrenceId'],
        'workItemId': value['workItemId'],
        'importMeasurementsForWorkSteps': ((value['importMeasurementsForWorkSteps'] as Array<any>).map(ImportTrackItMeasurementForWorkStepDtoToJSON)),
        '$type': value['$type'],
    });
}

